<template>
    <div class="myProfile-container">
        <div class="myProfile">
            <header>
                个人资料
            </header>
            <div class="form-container">
                <el-form ref="form" :model="form" label-width="80px" :rules="rules" label-position="top" :hide-required-asterisk="hideRequiredAsterisk">
                    <div class="left">
                        <el-form-item label="公开姓名" prop="teacherName">
                            <el-input v-model="form.teacherName"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="gender">
                            <el-radio-group v-model="form.gender">
                                <el-radio label="男">男</el-radio>
                                <el-radio label="女">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="地区" prop="city">
                            <el-cascader
                                    class="change-cascader"
                                    size="large"
                                    :options="provinceAndCityData"
                                    :props="{value: 'label'}"
                                    v-model="form.city">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="教学分类" prop="subject">
                            <el-cascader
                                    v-model="form.subject"
                                    :options="subjectList"
                                    :props="{label: 'name', value: 'name'}"
                            >
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="开始工作时间" prop="date">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.date" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="教授课程" prop="lessonList">
                            <el-input v-model="form.lessonList"></el-input>
                        </el-form-item>
                        <el-form-item label="真实姓名" prop="realName">
                            <el-input v-model="form.realName"></el-input>
                        </el-form-item>
                    </div>
                    <div class="left">
                        <el-form-item label="微信账号" prop="wx">
                            <el-input v-model="form.wx"></el-input>
                        </el-form-item>
                        <el-form-item label="学历" prop="education">
                            <el-select v-model="form.education" placeholder="请选择">
                                <el-option label="大专" value="大专"></el-option>
                                <el-option label="本科" value="本科"></el-option>
                                <el-option label="硕士" value="硕士"></el-option>
                                <el-option label="博士" value="博士"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="毕业院校" prop="graduated">
                            <el-input v-model="form.graduated"></el-input>
                        </el-form-item>
                        <el-form-item label="标签">
                            <el-select
                                    v-model="form.tags"
                                    multiple
                                    filterable
                                    allow-create
                                    default-first-option
                                    placeholder="请选择标签">
                                <el-option
                                        v-for="item in labelList"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="老师介绍" prop="introduction">
                            <el-input v-model="form.introduction" type="textarea" :rows="3"></el-input>
                        </el-form-item>
                        <el-form-item label="证书">
                            <div class="certificate-img" v-for="item in certificateIdList" :key="item.id" style="display: inline-block">
                                <el-upload
                                        class="avatar-uploader"
                                        :action="'/indexapp.php?c=Upload&a=UploadFileNew&id=' + id"
                                        :show-file-list="false"
                                        :http-request="arg => upload(arg, item.id)"
                                        accept="image/*"
                                >
                                    <img v-if="item.list" :src="imgPrefix + item.list[0]" class="certificate-img">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <p style="text-align: center; margin-top: -15px">{{item.name}}</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <el-form-item label="头像">
                            <img :src="imgPrefix + avatar" alt="" width="144" height="144" style="border-radius: 50%; object-fit: cover">
                            <el-upload
                                    class="avatar2-uploader"
                                    :action="'/indexapp.php?c=Upload&a=UploadFileNew&id=' + id"
                                    :show-file-list="false"
                                    :http-request="arg => upload(arg)"
                                    accept="image/*"
                            >
                                <el-button>更换头像</el-button>
                            </el-upload>
                        </el-form-item>
                    </div>
                    <el-form-item style="float: left; width: 100%" class="submit">
                        <el-button type="primary" @click="updateInfo">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right"></div>
        </div>
    </div>
</template>

<script>
    import {provinceAndCityData} from 'element-china-area-data';
    import {saveLocal, loadLocal} from '@/common/js/store.js';

    const defaultAvatar = 'datas/A9461100424T36QJ7B3BP/d1255219daf273f9f7fc9e53ddc85dae.png';

    Date.prototype.format = function(fmt) {
        var o = {
            "M+" : this.getMonth()+1,                 //月份
            "d+" : this.getDate(),                    //日
            "h+" : this.getHours(),                   //小时
            "m+" : this.getMinutes(),                 //分
            "s+" : this.getSeconds(),                 //秒
            "q+" : Math.floor((this.getMonth()+3)/3), //季度
            "S"  : this.getMilliseconds()             //毫秒
        };
        if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
        }
        for(var k in o) {
            if(new RegExp("("+ k +")").test(fmt)){
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
            }
        }
        return fmt;
    };

    export default {
        name: "MyProfile",
        data () {
            const userInfo = loadLocal('userinfo');
            const schoolNow = loadLocal('schoolNow');
            return {
                id: userInfo.id,
                rid: schoolNow.rid,
                avatar: defaultAvatar,
                profile: {},
                provinceAndCityData,
                imageUrl: '',
                subjectList: [],
                certificateIdList: [],
                labelList: [],
                imgPrefix: "https://edu.9man.com/Uploads/",
                form: {
                    teacherName: '',
                    realName: '',
                    gender: '男',
                    city: [],
                    subject: [],
                    date: '',
                    wx: '',
                    education: '',
                    graduated: '',
                    introduction: '',
                    tags: [],
                    lessonList: ''
                },
                rules: {
                    realName: [
                        { required: true, message: '请输入真实姓名', trigger: 'change' },
                        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'change' }
                    ],
                    teacherName: [
                        { required: true, message: '请输入公开姓名', trigger: 'change' },
                        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'change' }
                    ],
                    gender: [
                        { required: true, message: '请选择性别', trigger: 'change' },
                    ],
                    city: [
                        { required: true, message: '请选择所在地区', trigger: 'change' },
                    ],
                    subject: [
                        { required: true, message: '请选择教学分类', trigger: 'change' },
                    ],
                    date: [
                        { required: true, message: '请选择开课日期', trigger: 'change' },
                    ],
                    wx: [
                        { required: true, message: '请输入微信账号', trigger: 'change' },
                    ],
                    education: [
                        { required: true, message: '请选择学历', trigger: 'change' },
                    ],
                    graduated: [
                        { required: true, message: '请输入毕业院校', trigger: 'change' },
                    ],
                    introduction: [
                        { required: true, message: '请输入老师介绍', trigger: 'change' },
                    ],
                    lessonList: [
                        { required: true, message: '请输入教授课程', trigger: 'change' },
                    ],
                },
                hideRequiredAsterisk: true
            }
        },
        created () {
            this.getCertificateId();
            this.queryTeacherLabel();
            this.createSubjectList();
        },
        methods: {
            // 获取课程一级分类
            getLessonFirstType () {
                return this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Lesson',
                        a: 'QueryLessonType',
                        lang: 'zh',
                        parentid: 0
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        return data.list
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 获取课程二级分类
            getLessonSecondType () {
                return this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Lesson',
                        a: 'QueryLessonSecondType',
                        lang: 'zh',
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        return data.list
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 获取课程三级分类
            getLessonThirdType () {
                return this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Lesson',
                        a: 'QueryLessonThirdType',
                        lang: 'zh',
                        thirdtypeid: 1
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        return data.list
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 创建课程选择栏
            async createSubjectList () {
                let results = await Promise.all([this.getLessonFirstType(), this.getLessonSecondType(), this.getLessonThirdType()]);
                const subjectList = [...results[0]];
                const subjectSecondTypeObj = {};

                results[1].forEach(item => {
                    const parentId = item.parentid;
                    if (parentId === 7) {
                        item.children = results[2]
                    }
                    if (!subjectSecondTypeObj[parentId]) {
                        subjectSecondTypeObj[parentId] = [item];
                    } else {
                        subjectSecondTypeObj[parentId].push(item)
                    }
                });

                subjectList.forEach(item => {
                    item.children = subjectSecondTypeObj[item.id]
                });
                this.subjectList = subjectList;
            },

            // 获取个人资料
            queryUserProfile () {
                this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Teacher',
                        a: 'QueryTeacherOwnInfo',
                        id: this.id,
                        rid: this.rid
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        const profile = this.profile = data.list[0];
                        this.form.teacherName = decodeURIComponent(profile.teachername);
                        this.form.realName = decodeURIComponent(profile.realname);
                        this.form.gender = decodeURIComponent(profile.sex) || '男';
                        profile.area? this.form.city = decodeURIComponent(profile.area).split('/'): '';
                        this.form.lessonList = decodeURIComponent(profile.lessonlist);
                        profile.typename? this.form.subject = decodeURIComponent(profile.typename).split('/'): '';
                        profile.teacherage? this.form.date = new Date(profile.teacherage): '';
                        this.form.wx = profile.wxaccount;
                        this.form.education = decodeURIComponent(profile.education);
                        this.form.graduated = decodeURIComponent(profile.graduateschool);
                        profile.label? this.form.tags = decodeURIComponent(profile.label).split(','): '';
                        this.form.introduction = JSON.parse(decodeURIComponent(profile.introduce) || '[{"text": ""}]')[0].text;
                        profile.faceimg? this.avatar = profile.faceimg: '';
                        this.formatCertificate(profile.certificate);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 格式化证书
            formatCertificate (data) {
                const certificate = JSON.parse(decodeURIComponent(data) || '[]');
                if (certificate.length > 0) {
                    const certificateIdList = [...this.certificateIdList];
                    certificate.forEach(item => {
                        const certificateItem = certificateIdList.filter(value => value.id === item.id)[0];
                        certificateItem.list = item.list;
                    });
                    this.certificateIdList = certificateIdList;
                }
            },

            // 自定义上传
            upload (arg, id) {
                const file = arg.file;
                const url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
                this.$http({
                    url,
                    method: 'POST',
                    headers: {
                        'X-File-Name': encodeURIComponent(file.name),
                        'X-File-Size': file.size,
                        'X-File-Type': file.type
                    },
                    data: file,
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        this.handleCertificateImgSuccess(data, id);
                    }else {
                        this.$message.warning(data.msg)
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 证书上传成功
            handleCertificateImgSuccess (res, id) {
                if (res.code === 200) {
                    if (id) { // 存在id是上传的证书图片，否则是头像
                        const certificateIdList = [...this.certificateIdList];
                        const certificateObj = certificateIdList.filter(item => item.id === id)[0];
                        Object.assign(certificateObj, {list: [res.image]});
                        this.certificateIdList = certificateIdList;
                    } else {
                        this.avatar = res.image;
                    }
                }
            },

            // 获取证书列表
            getCertificateId () {
                this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Teacher',
                        a: 'QueryTeacherCerLabel',
                        id: this.id,
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        this.certificateIdList = data.list;
                        this.queryUserProfile();
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 获取标签
            queryTeacherLabel () {
                this.$http({
                    url: '/indexapp.php',
                    method: 'GET',
                    params: {
                        c: 'Teacher',
                        a: 'QueryTeacherLabel',
                        id: this.id,
                    }
                }).then(res => {
                    const data = res.data;
                    if (data.code === 200) {
                        const list = data.list;
                        const labelList = list.reduce((total, currentValue) => {
                            return total.concat(currentValue.list)
                        }, []);
                        this.labelList = labelList;
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },

            // 更新个人信息
            updateInfo () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const form = this.form;
                        const params = {
                            id: this.id,
                            rid: this.rid,
                            teachername: form.teacherName,
                            realname: form.realName,
                            sex: form.gender,
                            area: form.city.join('/'),
                            lessonlist: form.lessonList,
                            typename: form.subject.join('/'),
                            teacherage: form.date.format('yyyy-MM-dd'),
                            wx: form.wx,
                            education: form.education,
                            graduateschool: form.graduated,
                            label: form.tags.length > 0? form.tags.join(','): '',
                            introduce: JSON.stringify([{isImage: false, text: form.introduction}]),
                            faceimg: this.avatar,
                            certificate: JSON.stringify(this.certificateIdList),
                        };
                        this.$http({
                            url: '/indexapp.php?c=Teacher&a=UpdateRoomTeacherOwnerInfo',
                            method: 'post',
                            data: params,
                            transformRequest: [data => {
                                let ret = ''
                                for (let it in data) {
                                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                                }
                                return ret
                            }],
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        }).then(res => {
                            const data = res.data;
                            if (data.code === 200) {
                                this.$message.success('更新成功');
                            }else {
                                this.$message.warning(data.msg);
                            }
                        }).catch((err) => {
                            console.log(err);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
.myProfile-container {
    padding: 40px 0 24px 160px;
    background-color: #f2f2f2;
    box-sizing: border-box;
    position: relative;
    min-height: 100%;
    .myProfile {
        margin: 24px 24px 0 24px;
        padding: 24px;
        background-color: #fff;
        color: rgba(0,0,0,.65);
        min-width: 985px;
        header {
            margin-bottom: 12px;
            color: rgba(0,0,0,.85);
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
        }
        .form-container {
            .el-form {
                overflow: hidden;
                .left {
                    float: left;
                    width: 350px;
                    margin-right: 24px;
                }
                .right {
                    float: left;
                    margin-left: 80px;
                }
            }
            padding-top: 12px;
        }
        .el-form-item {
            &.submit {
                margin-top: 15px;
                margin-bottom: 0;
                .el-form-item__content {
                    text-align: center;
                }
            }
            label {
                height: 30px;
                line-height: 20px;
            }
            .el-cascader {
                width: 100%;
            }
            .el-select {
                width: 100%;
            }
            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width: 100px;
                height: 100px;
                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                }
            }
            .avatar2-uploader {
                .el-upload {
                    margin-left: 23px;
                }
            }
            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .avatar {
                width: 100px;
                height: 100px;
                display: block;
            }
            .certificate-img:nth-of-type(2) {
                margin: 0 22px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/myProfile/MyProfile.vue